<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
	<polygon points="11,8 11,11 8,11 8,12 12,12 12,8" />
	<polygon points="1,1 4,1 4,0 0,0 0,4 1,4" />
	<polygon points="4,11 1,11 1,8 0,8 0,12 4,12" />
	<polygon points="11,1 11,4 12,4 12,0 8,0 8,1" />
</svg>
</template>